module.exports = __webpack_public_path__ + "static/link-stockists-a768b456dee36f8f8620b76faf4c5091.png";